import React, { useEffect, useState } from 'react';
import Breadcumb from '../Layouts/Breadcumb';
import { Grid, TextField } from '@mui/material';
import axios from 'axios';
import { Constants } from '../endPoints';
import Swal from 'sweetalert2';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { jwtDecode } from 'jwt-decode';
import { MuiTelInput } from 'mui-tel-input';

export default function Contact() {

  const [initialValues, setInitialValues] = useState({
    name: '',
    email: '',
    phone_number: '',
    message: '',
  });

  // ✅ Validation Schema
  const ContactSchema = Yup.object().shape({
    name: Yup.string()
      .matches(/^[A-Za-z\s]+$/, 'Only alphabets are allowed')
      .min(2, 'Too short')
      .max(50, 'Too long')
      .required('Name is required'),

    email: Yup.string()
      .required('Email is required')
      .test(
        'valid-email',
        'Enter a valid email address',
        (value) => {

          if (!value) return false;

          // basic email format
          const emailRegex =
            /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+\.[A-Za-z]{2,}$/;

          if (!emailRegex.test(value)) {
            return false;
          }

          // prevent repeated extensions
          const parts = value.toLowerCase().split('.');

          const last = parts[parts.length - 1];
          const secondLast = parts[parts.length - 2];

          if (last === secondLast) {
            return false;
          }

          return true;
        }
      ),

    phone_number: Yup.string()
      .required('Phone number is required')
      .test('valid-phone', 'Invalid phone number', value => {
        if (!value) return false;
        const cleaned = value.replace(/\s/g, '');
        return /^\+\d{10,15}$/.test(cleaned);
      }),

    message: Yup.string()
      .required('Message is required'),
  });

  // ✅ Auto-fill user data
  useEffect(() => {
    const token = localStorage.getItem('authToken');

    if (token) {
      const decoded = jwtDecode(token);
      const userId = decoded.id;

      const fetchUserDetails = async () => {
        try {
          const res = await axios.get(`${Constants.userInfoById}/${userId}`);

          if (res.data.status === 1) {
            const user = res.data.data;

            setInitialValues(prev => ({
              ...prev,
              name: user.name || '',
              email: user.email || '',
              phone_number: user.phone || ''
            }));
          }
        } catch (err) {
          console.error('Error fetching user info:', err);
        }
      };

      fetchUserDetails();
    }
  }, []);

  // ✅ Submit
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {

      // 🔥 Clean phone before API
      const cleanedValues = {
        ...values,
        phone_number: values.phone_number.replace(/\s/g, '')
      };

      const res = await axios.post(Constants.addContact, cleanedValues);

      if (res.data.status === 1) {
        Swal.fire({
          icon: 'success',
          title: 'Thank you!',
          text: 'Your message has been submitted.',
        });
        resetForm();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops!',
          text: res.data.message || 'Something went wrong.',
        });
      }

    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Server error!',
        text: 'Please try again later.',
      });
    }

    setSubmitting(false);
  };

  return (
    <>
      <Breadcumb pagetitle="Contact Us" />

      <section className='inner_body'>
        <div className='container pagehding'>
          <Grid container spacing={1} justifyContent="center">

            <Grid item lg={5} md={6} sm={12} xs={12}>

              <div className='contact_box border'>

                <div className='contact_heading text-center'>
                  <h2 className="mb-4 text-center">Write Us</h2>
                  <p className='text-gray-600'>
                    For all enquiries, please email us using the form below and we’ll get back to you as quickly as possible.
                  </p>
                </div>

                <Formik
                  initialValues={initialValues}
                  enableReinitialize
                  validationSchema={ContactSchema}
                  onSubmit={handleSubmit}
                >
                  {({ isSubmitting }) => (

                    <Form>

                      {/* NAME */}
                      <div className='mb-3'>
                        <Field
                          as={TextField}
                          label="Name"
                          name="name"
                          fullWidth
                          inputProps={{
                            maxLength: 50
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          }}
                        />
                        <ErrorMessage name="name" component="div" className="error_msg text-sm mt-1" />
                      </div>

                      {/* EMAIL */}
                      <div className='mb-3'>
                        <Field
                          as={TextField}
                          label="Email"
                          name="email"
                          fullWidth
                        />
                        <ErrorMessage name="email" component="div" className="error_msg text-sm mt-1" />
                      </div>

                      {/* ✅ PHONE INPUT (FIXED) */}
                      {/* <div className='mb-3'>
                                                <Field name="phone_number">
                                                    {({ field, form, meta }) => (
                                                        <MuiTelInput
                                                            defaultCountry="IN"
                                                            value={field.value || ""}
                                                            onChange={(value) => {
                                                                form.setFieldValue("phone_number", value);
                                                            }}
                                                            onBlur={() => form.setFieldTouched("phone_number", true)}
                                                            fullWidth
                                                            label="Phone Number"

                                                            error={meta.touched && Boolean(meta.error)}
                                                            helperText={meta.touched && meta.error}

                                                            MenuProps={{
                                                                PaperProps: {
                                                                    sx: {
                                                                        maxHeight: 200
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                </Field>
                                            </div> */}

                      <div className='mb-3'>
                        <Field name="phone_number">
                          {({ field, form, meta }) => (
                            <MuiTelInput
                              defaultCountry="IN"
                              forceCallingCode
                              value={field.value || ""}
                              onChange={(value, info) => {

                                // keep country code fixed
                                const countryCode = `+${info.countryCallingCode}`;

                                // prevent removing country code
                                if (!value.startsWith(countryCode)) {
                                  value = countryCode;
                                }

                                form.setFieldValue("phone_number", value);
                              }}
                              onBlur={() =>
                                form.setFieldTouched("phone_number", true)
                              }
                              fullWidth
                              label="Phone Number"
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}

                              MenuProps={{
                                PaperProps: {
                                  sx: {
                                    maxHeight: 200
                                  }
                                }
                              }}

                              inputProps={{
                                onKeyDown: (e) => {
                                  const input = e.target;

                                  // prevent deleting country code
                                  const selectionStart = input.selectionStart;

                                  if (
                                    (e.key === "Backspace" || e.key === "Delete") &&
                                    selectionStart <= input.value.indexOf(" ") + 1
                                  ) {
                                    e.preventDefault();
                                  }
                                }
                              }}
                            />
                          )}
                        </Field>
                      </div>

                      {/* MESSAGE */}
                      <div className='mb-3'>
                        <Field
                          as={TextField}
                          label="What’s on your mind? *"
                          name="message"
                          multiline
                          rows={4}
                          fullWidth
                        />
                        <ErrorMessage name="message" component="div" className="error_msg text-sm mt-1" />
                      </div>

                      {/* SUBMIT */}
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="submit_btn text-white"
                      >
                        {isSubmitting ? 'Submitting...' : 'Submit'}
                      </button>

                    </Form>
                  )}
                </Formik>

              </div>
            </Grid>
          </Grid>
        </div>
      </section>
    </>
  );
}